<template>
  <v-expansion-panel>
    <v-expansion-panel-title>
      <h4 class="mb-0 me-2">{{ header }}</h4>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <slot />
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script setup lang="ts">
defineProps<{
  header: string;
}>();
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 0;
  border-top: 1px solid #fff;
  font-size: 16px;
}
.v-expansion-panel-title {
  padding: var(--space-3) 0;
}
:deep(.v-expansion-panel-title__overlay) {
  display: none;
}
:deep(.v-expansion-panel-title__icon) {
  margin-inline-start: initial;
}
:deep(.v-expansion-panel-text__wrapper) {
  padding: var(--space-4) 0;
}
</style>